import { render, staticRenderFns } from "./BasePromoModuleGrid.vue?vue&type=template&id=3e80a269&scoped=true&"
import script from "./BasePromoModuleGrid.vue?vue&type=script&lang=js&"
export * from "./BasePromoModuleGrid.vue?vue&type=script&lang=js&"
import style0 from "./BasePromoModuleGrid.vue?vue&type=style&index=0&id=3e80a269&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e80a269",
  null
  
)

export default component.exports